export { default } from "@material-ui/core/styles/createTypography";
export * from "@material-ui/core/styles/createTypography";
